import styled, { css } from 'styled-components';

export const Title = styled.h3`
  ${({ theme }) => css`
    padding: 32px 32px 0;
    margin: 0;
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.lg};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: normal;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 24px 24px 0;
      font-size: ${theme.v2.font.sizes.md};
    }
  `}
`;

export const DragArea = styled.label`
  ${({ theme }) => css`
    margin: 24px 32px 24px;
    padding: 28px 24px;
    border: 2px dashed ${theme.v2.colors.neutral.highMedium};
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 16px 16px 16px;
      padding: 20px 16px;
    }
  `}
`;

export const DragText = styled.p`
  ${({ theme }) => css`
    text-align: center;
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: normal;
    max-width: 480px;
    margin: 8px 0 4px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxxs};
      max-width: 100%;
    }
    
    strong, b {
      font-weight: ${theme.v2.font.weights.bold};
    }
  `}
`;

export const Recommendation = styled.p`
  ${({ theme }) => css`
    text-align: center;
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: normal;
    max-width: 480px;
    margin: 0 0 12px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxxs};
      max-width: 100%;
    }
    
    strong, b {
      font-weight: ${theme.v2.font.weights.bold};
    }
  `}
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const Uploading = styled.div`
  margin: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const UploadingName = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    margin-bottom: 8px;
  `}
`;

export const CancelWrapper = styled.div`
  margin-top: 8px;
`;

export const ErrorText = styled.p`
  ${({ theme }) => css`
    margin-top: 16px;
    color: ${theme.v2.colors.feedback.problemPure};
    text-align: center;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: normal;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxxs};
    }
    
    strong, b {
      font-weight: ${theme.v2.font.weights.bold};
    }
  `}
`;

export const CameraIconWrapper = styled.div`
  ${({ theme }) => css`
    margin: 8px 0 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.v2.colors.brand.primaryMedium};

    svg {
      width: 48px;
      height: 48px;

      @media (max-width: ${theme.v2.breakpoints.md}) {
        width: 40px;
        height: 40px;
      }
    }
  `}
`;
